import React from 'react'
import { Provider } from "react-redux";
import { createStore, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";
import reducers from "./reducers";

import SidePanel from './components/SidePanel'
import MainAgenda from './components/MainAgenda'
import FabButtons from './components/FabButtons'

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = (initialState) => {
  return createStore(
    reducers,
    initialState,
    composeEnhancers(
      applyMiddleware(
        thunk
      )
    )
  );
}

export default function Root(props) {
  const { showSidePanel, height, isStaffApp } = props.config
  return (
    <Provider store={store(props)}>
      <div className="d-flex align-items-start" style={{ height }}>
        {showSidePanel && <SidePanel variant="popover" />}
        {<FabButtons {...{ isStaffApp }} />}
        <div className="h-100 d-lg-flex align-items-start w-100 main-container" style={{ backgroundColor: isStaffApp ? 'white' : 'rgba(256,256,256,0.5)', overflowY: 'visible' }}>
          {showSidePanel && <SidePanel />}
          <MainAgenda />
          <div />
        </div>
      </div>
    </Provider>
  )
}